
/* injects from baggage-loader */
require('./style.scss');

import React, { useEffect, useState } from "react";
import { useDataFetch } from "../customHooks/dataFetch";
import Loader from "../../components/loader";
import Zergling from "@app/dev/helpers/zergling";
import { TournamentTypeEnum } from "@app/dev/constants/enums/tournament";
import TournamentListItem from "./components/listItem";

const Tournaments = () => {
	const [refetchCounter, setRefetchCounter] = useState(0);
	const [data, , initialLoading] = useDataFetch(
		() => Zergling.get({ product_type_id: TournamentTypeEnum.Sport }, "get_tournament_list"),
		[refetchCounter]
	);

	useEffect(() => {
		const timeout = setTimeout(() => setRefetchCounter(refetchCounter + 1), 20000);
		return () => clearTimeout(timeout);
	}, [refetchCounter]);

	if (initialLoading) return <Loader component="tournaments" />;

	return data ? (
		<secion className="tournaments-wrapper">
			{data.result.map(item => (
				<TournamentListItem key={item.Id} tournament={item} />
			))}
		</secion>
	) : null;
};

export default Tournaments;
